import * as React from 'react';
import { WithStyles } from '@material-ui/core/styles/withStyles';
import { translation } from '../../../i18n';
import { Typography } from '@material-ui/core';
import { ExpansionPanelDetails } from '@material-ui/core';
import { QuestionDto } from '../../../pages/questionTypes';
import { Chip } from '@material-ui/core';
import { observer } from 'mobx-react';
import MultilineText from '../../MultilineText';

interface Props {
  question: QuestionDto;
}

type LocalStyles = 'detailArea' | 'chip';

type PropsWithStyle = WithStyles<LocalStyles> & Props;

@observer
class MultipleChoiceQuestionPreview extends React.Component<PropsWithStyle, {}> {

  constructor(props: PropsWithStyle) {
    super(props);
  }

  public render() {
    const {question} = this.props;
    return (
      <ExpansionPanelDetails className={this.props.classes.detailArea}
                             key={question.id + 'multiple-choice-question-details'}>
        {
          question.description &&
          <>
            <div>
              <Typography style={{textAlign: 'left'}}>
                <MultilineText text={question.description}/>
              </Typography>
            </div>
            <br/>
          </>
        }
        {
          question.enableComment &&
          <>
            <div>
              <Typography style={{textAlign: 'left'}}>
                {translation.t('question.comment')}
              </Typography>
            </div>
            <br/>
          </>
        }
        <div>
          <Typography style={{textAlign: 'left'}}>
            {translation.t('question.choice')}:
          </Typography>
        </div>
        <div>
          {
            question.choices!!.map(choice => (
              <Chip key={choice.id} label={choice.description} className={this.props.classes.chip}/>
            ))
          }

        </div>
      </ExpansionPanelDetails>
    );
  }
}

export default MultipleChoiceQuestionPreview;
